import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'remove-background' as const;

const sourceImageSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('url'),
    url: z.string().describe('URL of the source image'),
  }),
  z.object({
    type: z.literal('base64'),
    base64: z.string().describe('Base64-encoded image data'),
    mimeType: z
      .string()
      .describe('MIME type of the image (e.g. image/png, image/jpeg)'),
  }),
]);

const argumentZod = z.object({
  sourceImage: sourceImageSchema.describe(
    'The source image to remove the background from'
  ),
  outputFormat: z
    .enum(['png', 'webp'])
    .optional()
    .describe(
      'Output format for the transparent image. Defaults to png. Must support alpha channel.'
    ),
});

export const removeBackgroundManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Remove background',
  prettyStatus: {
    executed: 'Removed background',
    executing: 'Removing background',
    failed: 'Failed to remove background',
  },
  llmTool: {
    name: toolName,
    description:
      'Removes the background from an image, producing a transparent PNG. The subject is preserved and the background becomes fully transparent (alpha channel).',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteFile', action: 'manage'}],
  confirmBeforeExecuting: false,
  timeout: 120_000,
});
